import React, { Component } from 'react';
import ViewHeader from '../../components/ViewHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { FaPencilAlt, FaRegWindowClose } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Image as NativeImage } from 'react-native';
import { bindActionCreators } from 'redux';
import FormTemplate from '../../components/FormTemplate';
import { Row, Col, FormGroup, FormLabel } from 'react-bootstrap';
import { MODE_ADD, NOTIF_ERROR, NOTIF_SUCCESS, SUCCESS, ADTYPE_REDEEM, ADS_IMAGE, ADS_DETAILS, SECONDARY, CANCEL, SUCCESS_BUTTON, SAVE, STORE_NAME, NO, YES } from '../../../utils/constants';
import { isNullOrUndefined } from 'util';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import ConfirmationModal from '../../components/ConfirmationModal';
import { SideNotification, isValidImageType, adsImageStyle } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, MSG_CONFIRM_CHANGES, ADS_IMAGE_REQUIRED, RECOMMENENDED_SIZE, SAVE_CHANGES, MSG_INVALID_IMAGE_TYPE } from '../../../utils/messages';
import { withRouter } from 'react-router-dom';
import { EditorState } from 'draft-js';
import adsDummyImg from '../../../includes/img/adsDummy.jpg';
import * as adsSelectors from '../Advertisments/state/selectors';
import * as adsOperations from '../Advertisments/state/operations';
import debounce from 'lodash.debounce';

class AddAdvertisement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imageFile: null,
            imageFileUrl: null,
            storeId: props.storeDetails.storeId,
            adsId: 0,
            mode: MODE_ADD,
            imageHash: Date.now(),
            imageError: false,
            showSaveModal: false,
            showDeleteModal: false,
            adsDetails: [],
            editorState: EditorState.createEmpty(),
            initialForm: {
                AdsModel: {
                    adsTitle: '',
                    adTypeId: ADTYPE_REDEEM,
                    startDate: '',
                    endDate: '',
                    redemptionLimit: 0,
                    adsDescription: ''
                }
            }
        }

        //Required to make submission possible on external button
        this.storeForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
    }

    uploadImageContainer = () => {
        return (
            <React.Fragment>
                <Row style={{ padding: 0 }}>
                    <Col md={6} style={{ padding: 0 }}>
                        <img src={adsDummyImg} width={150} alt="phone reference" />
                    </Col>

                    <Col md={6} style={{ padding: 0 }}>
                        <center><label><b className={"required-input"}>{ADS_IMAGE}</b></label><br /></center><br />
                        <Col className="flex-align">
                            <center>
                                <NativeImage
                                    source={{ uri: (isNullOrUndefined(this.state.imageFile) ? `${REST_SERVICE_URL_ROOT}/ads/image/00?${this.state.imageHash}` : this.state.imageFileUrl) }}
                                    style={adsImageStyle}
                                    resizeMode={(MODE_ADD === this.state.mode && isNullOrUndefined(this.state.imageFile)) ? "contain" : "cover"}
                                />
                            </center>
                        </Col>
                        <br />
                        <div className="flex-align">
                            <div>
                                <center>
                                    {this.state.imageError && <><label className="formik-error">{ADS_IMAGE_REQUIRED}</label><br /></>}
                                    <input type='file' id='photo' accept='image/*' onChange={this.handleImageFile} style={{ width: 240 }} /><br /><br />
                                    <b>{RECOMMENENDED_SIZE}</b>
                                </center>
                            </div>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderRightButtons = () => {
        return [
            { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.resetAdsForm() },
            { variant: SUCCESS_BUTTON, label: SAVE , icon: FaPencilAlt, onClick: this.onSubmitClick },
        ]
    }

    handleImageFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            this.setState({ imageFile: event.target.files[0], imageFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]) }, () => { MODE_ADD === this.state.mode && this.setState({ imageError: isNullOrUndefined(this.state.imageFile) }) })
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {
        this.form.submitForm();
        if (MODE_ADD === this.state.mode) {
            this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
        }
    }

    resetAdsForm = () => {
        this.form.resetForm();
        this.setState({ editorState: EditorState.createEmpty(), imageFile: null, imageFileUrl: null, imageError: false })
    }

    handleSubmit = (values) => {
        if (isNullOrUndefined(this.state.imageFile) && MODE_ADD === this.state.mode) {
            this.setState({ imageError: true })
        } else {
            this.setState({ imageError: false, adsDetails: values }, () => this.toggleSave());
        }
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    saveChanges = () => {
        let values = this.state.adsDetails;
        values.AdsModel.storeId = this.state.storeId;

        this.props.insertAd(values.AdsModel, this.state.imageFile, false)
            .then(result => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.toggleSave();
                    this.resetAdsForm();
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    updateEditorState = (editorState) => {
        this.setState({ editorState })
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={ADS_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />
                <Row style={{ paddingTop: '30px' }}>
                    <Col md={6} className="flex-align">
                        <div>{this.uploadImageContainer()}</div>
                    </Col>

                    <Col md={6} className="flex-align">
                        <FormTemplate
                            initialValues={this.state.initialAdsDetails}
                            bindSubmitFormik={this.bindSubmitFormik}
                            formInputs={this.props.adsForm}
                            validate={adsSelectors.validateForm}
                            updateFormRef={this.updateFormRef}
                            handleSubmit={this.handleSubmit}
                            editorState={this.state.editorState}
                            updateEditorState={this.updateEditorState}
                            selectInput={this.props.adTypeSelection}
                            storeId={this.state.storeId}
                            additionalField={
                                <Col md={12} xs={12}>
                                    <FormGroup className={"form-input"}>
                                        <FormLabel>{STORE_NAME}</FormLabel><br />
                                        <label>{this.props.storeDetails.storeName}</label>
                                    </FormGroup>

                                </Col>
                            }
                        />
                    </Col>
                </Row>
                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

            </ModuleContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        adsForm: state.ads.adsForm,
        adTypeSelection: state.ads.adTypeSelection,
        storeDetails: state.auth.storeDetails
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertAd: adsOperations.insertAd
    },
    dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddAdvertisement));